import {Component, Injector} from '@angular/core';
import {BaseComponent} from '../../../../shared/components/base.component';
import {Point} from '../../../../shared/models/geometry/point.model';
import {Coordinate} from '../../../../shared/models/generic/coordinate.model';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'zoom-toolbox',
  templateUrl: './zoom-toolbox.component.html',
  styleUrls: ['./zoom-toolbox.component.scss']
})
export class ZoomToolboxComponent extends BaseComponent {

  private homePoint: Point;

  constructor(injector: Injector) {
    super(injector);
    if (this.userService.isPlatformOrRealmManager()) {
      this.realmService.getRealm(this.authService.getRealmId()).subscribe(realm => {
        this.regionService.getRegion(realm.regionId).subscribe(region => {
          this.homePoint = region.getCenter();
        });
      });
    } else {
      if (environment.map.framework === 'Maplibre') {
        const point = {
          type: 'Point',
          coordinates: [environment.map.maplibre.center.lat, environment.map.maplibre.center.lng]
        };
        this.homePoint = point;
      } else if (environment.map.framework === 'Leaflet') {
        const point = {
          type: 'Point',
          coordinates: [environment.map.leaflet.center.lng, environment.map.leaflet.center.lat]
        };
        this.homePoint = point;
      }

    }

  }

  onZoomInClicked(): void {
    this.eventService.broadcastZoomInEvent();
  }

  onZoomOutClicked(): void {
    this.eventService.broadcastZoomOutEvent();
  }

  onGoHomeButtonClicked(): void {
    this.eventService.broadcastGoHomeEvent(new Coordinate({latitude: this.homePoint.coordinates[0], longitude: this.homePoint.coordinates[1]}), 6, 1.5);
  }
}
